import {
  Button,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
} from '@chakra-ui/react';
import { useMemo } from 'react';
import { FiUser } from 'react-icons/fi';
import PasswordInput from '../common/PasswordInput';

export default function LoginForm({
  email,
  setEmail,
  password,
  setPassword,
  isPending = false,
}: {
  email: string;
  setEmail: (email: string) => void;
  password: string;
  setPassword: (password: string) => void;
  isPending: boolean;
}) {
  const isDisabled = useMemo(
    () => !email.trim() || !password.trim(),
    [email, password],
  );

  return (
    <>
      <FormControl mt='4'>
        <FormLabel>Email</FormLabel>
        <InputGroup size='lg'>
          <InputLeftElement>
            <FiUser />
          </InputLeftElement>
          <Input
            type='text'
            placeholder='sales@procurabusiness.com'
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </InputGroup>
      </FormControl>

      <FormControl>
        <FormLabel>Password</FormLabel>
        <PasswordInput password={password} setPassword={setPassword} />
      </FormControl>

      <Button
        type='submit'
        variant='procura'
        size='lg'
        w='full'
        mt='4'
        py='4'
        fontSize='sm'
        isDisabled={isDisabled}
        isLoading={isPending}
      >
        Login
      </Button>
    </>
  );
}
